module.exports = __webpack_public_path__ + "static/media/about-warsaw.1629a011.mp4";